import { createElement } from "react";
import React from "react";
import { useCtx } from "../Context.jsx";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { SkeletonItem, Skeleton, CardHeader, Divider, ListItem, List, Caption1, PopoverSurface, PopoverTrigger, Popover, Button, Caption2, Badge, Label, tokens, Text as Text$, ProgressBar, Field, Subtitle2, Image, CardPreview, Card } from "@fluentui/react-components";
import { comparePrimitives, safeHash, equals, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { toArray, take, length, tryHead, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { sortBy, map, mapIndexed, concat, sumBy, contains, collect } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { CheckmarkLockRegular, LockClosedRegular, CheckmarkCircleRegular, QuestionRegular, ArrowRightRegular, BookOpenRegular, LayerRegular } from "@fluentui/react-icons";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { tap } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { successToast, errorToast, infoToast } from "../Toasts.jsx";
import { startAsPromise } from "../fable_modules/fable-library-js.4.24.0/Async.js";
import { Task, toastServerError, Track } from "../ApiClient.jsx";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { dataFetchFailedView } from "../Helpers.jsx";

function HeaderCard(headerCardInputProps) {
    let elems_8, el_2, el, elems_7, elems_5, elems_1, elems_4, elems_2, el_13, el_15, elems_3, elems_6;
    const userCompletedTasks = headerCardInputProps.userCompletedTasks;
    const setUserIsTakingTrack = headerCardInputProps.setUserIsTakingTrack;
    const userIsTakingTrack = headerCardInputProps.userIsTakingTrack;
    const track = headerCardInputProps.track;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const el_33 = Card;
    return createElement(el_33, createObj(ofArray([["style", {
        minHeight: 35 + "vh",
        display: "flex",
        padding: 0,
    }], (elems_8 = [(el_2 = CardPreview, createElement(el_2, {
        children: (el = Image, createElement(el, {
            style: {
                height: 15 + "vh",
            },
            fit: "cover",
            src: "https://4kwallpapers.com/images/walls/thumbs_3t/1462.jpg",
        })),
    })), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexGrow", 1]), delay(() => append(singleton(["flexWrap", "wrap"]), delay(() => append(singleton(["justifyContent", "space-between"]), delay(() => append(singleton(["padding", 15]), delay(() => append(singleton(["gap", 15 + "px "]), delay(() => {
        const matchValue = screenSize;
        switch (matchValue.tag) {
            case 0:
            case 1:
                return singleton(["justifyContent", "center"]);
            default: {
                return empty();
            }
        }
    })))))))))))))))], (elems_7 = [createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => {
        let matchValue_1;
        return append((matchValue_1 = screenSize, (matchValue_1.tag === 0) ? (empty()) : ((matchValue_1.tag === 1) ? (empty()) : singleton(["maxWidth", 60 + "%"]))), delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["gap", 5 + "px "]), delay(() => append(singleton(["flexDirection", "column"]), delay(() => singleton(["justifyContent", "space-between"])))))))));
    })))], (elems_5 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 5 + "px ",
    }], (elems_1 = toList(delay(() => {
        let el_4;
        return append(singleton((el_4 = Subtitle2, createElement(el_4, {
            children: track.Name,
        }))), delay(() => {
            let el_9, matchValue_2, el_6;
            let fraction;
            const allTasksInTrack = collect((_arg) => _arg.RequiredTasks, track.TrackLevels);
            const totalCompleted = allTasksInTrack.filter((t) => contains(t, userCompletedTasks, {
                Equals: equals,
                GetHashCode: safeHash,
            }));
            fraction = (totalCompleted.length / allTasksInTrack.length);
            return append(singleton((el_9 = Field, createElement(el_9, {
                validationMessage: `${~~(fraction * 100)} % fullført`,
                validationState: "none",
                children: (matchValue_2 = tryHead([(el_6 = ProgressBar, createElement(el_6, {
                    thickness: "large",
                    shape: "rounded",
                    color: "brand",
                    value: fraction,
                }))]), (matchValue_2 == null) ? defaultOf() : matchValue_2),
            }))), delay(() => {
                let el_11;
                return singleton((el_11 = Text$, createElement(el_11, {
                    children: track.Description,
                    style: {
                        color: tokens.colorNeutralForeground3,
                    },
                })));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 20 + "px ",
    }], (elems_4 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_2 = [(el_13 = LayerRegular, createElement(el_13, {
        fontSize: 24,
        primaryFill: tokens.colorBrandBackground,
    })), (el_15 = Label, createElement(el_15, {
        size: "medium",
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: `${track.TrackLevels.length} nivåer`,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_3 = toList(delay(() => {
        let el_17;
        return append(singleton((el_17 = BookOpenRegular, createElement(el_17, {
            fontSize: 24,
            primaryFill: tokens.colorBrandBackground,
        }))), delay(() => {
            let el_19;
            return append(singleton((el_19 = Label, createElement(el_19, {
                size: "medium",
                style: {
                    color: tokens.colorNeutralForeground3,
                },
                children: `${sumBy((_arg_1) => _arg_1.TrackLevelCourses.length, track.TrackLevels, {
                    GetZero: () => 0,
                    Add: (x_1, y_1) => (x_1 + y_1),
                })} kurs`,
            }))), delay(() => {
                let el_23, el_21;
                return (ctx.User.IsAdmin && !track.Enabled) ? singleton((el_23 = Badge, createElement(el_23, {
                    style: {
                        marginLeft: 10,
                    },
                    appearance: "tint",
                    color: "warning",
                    size: "large",
                    children: (el_21 = Caption2, createElement(el_21, {
                        children: "Utkast",
                    })),
                }))) : empty();
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexDirection", "column"]), delay(() => {
        let matchValue_3;
        return append((matchValue_3 = screenSize, (matchValue_3.tag === 0) ? singleton(["flexGrow", 1]) : ((matchValue_3.tag === 1) ? singleton(["flexGrow", 1]) : (empty()))), delay(() => singleton(["gap", 5 + "px "])));
    })))))))], (elems_6 = toList(delay(() => {
        let el_25;
        return append(ctx.User.IsAdmin ? singleton((el_25 = Button, createElement(el_25, {
            children: "Rediger",
            appearance: "primary",
            onClick: (_arg_2) => {
                RouterModule_nav(ofArray(["kurslop", "bygger", `${track.Id}`]), 1, 1);
            },
        }))) : empty(), delay(() => {
            let el_29, el_27;
            return append(!userIsTakingTrack ? singleton((el_29 = Button, createElement(el_29, {
                icon: (el_27 = ArrowRightRegular, createElement(el_27, {})),
                iconPosition: "after",
                children: "Meld på",
                appearance: "primary",
                onClick: (_arg_3) => {
                    const pr = tap((res) => {
                        if (res.tag === 1) {
                            switch (res.fields[0].tag) {
                                case 2: {
                                    setUserIsTakingTrack(true);
                                    infoToast(setCtx, "alreadySignedUpError", "Allerede påmeldt", `Du er allerede påmeldt ${track.Name}`, undefined);
                                    break;
                                }
                                case 1: {
                                    setUserIsTakingTrack(true);
                                    infoToast(setCtx, "disabledError", "Kunne ikke melde på", "Kursløpet er ikke publisert", undefined);
                                    break;
                                }
                                default:
                                    errorToast(setCtx, "signUpError", "Kunne ikke melde på", "Noe gikk galt", undefined);
                            }
                        }
                        else {
                            setUserIsTakingTrack(true);
                            successToast(setCtx, "signUpSuccess", "Påmeldt", `Du ble påmeldt ${track.Name}`);
                        }
                    }, startAsPromise(Track.SignUp(track.Id)));
                    void (pr.catch((ex) => {
                        toastServerError(setCtx, ex);
                    }));
                },
            }))) : empty(), delay(() => {
                let el_31;
                return singleton((el_31 = Button, createElement(el_31, {
                    disabled: true,
                    children: "Se tilgjengelige kurs",
                })));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_8))])])));
}

function TrackOverview(trackOverviewInputProps) {
    let elems_15;
    const completedTasks = trackOverviewInputProps.completedTasks;
    const track = trackOverviewInputProps.track;
    const isMobile = equals(useFeliz_React__React_useResponsive_Static_Z434A9929(), new ScreenSize(0, []));
    const patternInput = useCtx();
    const el_64 = Card;
    return createElement(el_64, createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
    }], (elems_15 = toList(delay(() => {
        let elems_2, el, el_16;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            width: 100 + "%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        }], (elems_2 = [(el = Subtitle2, createElement(el, {
            children: "Programstruktur",
        })), (el_16 = Popover, createElement(el_16, createObj(toList(delay(() => append(isMobile ? singleton(["positioning", "below-start"]) : singleton(["positioning", "before"]), delay(() => {
            let elems_1, el_6, el_4, el_2, el_14, elems, el_8, text_2, el_10, text_3, el_12, elemsToUse;
            return singleton((elems_1 = [(el_6 = PopoverTrigger, createElement(el_6, {
                children: (el_4 = Button, createElement(el_4, {
                    icon: (el_2 = QuestionRegular, createElement(el_2, {})),
                    appearance: "subtle",
                })),
            })), (el_14 = PopoverSurface, createElement(el_14, createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                maxWidth: isMobile ? (75 + "vw") : (400 + "px"),
            }], (elems = [(el_8 = Subtitle2, createElement(el_8, {
                children: "Læringsløp",
            })), (text_2 = "Her vises de forskjellige nivåene for dette læringsløpet og hvilke betingelser som kreves for å tilfredsstille disse. Hvert nivå inneholder både kurs og oppgaver, hvor oppgaver kan være betingelser for å komme på videre nivåer.", (el_10 = Caption1, createElement(el_10, {
                children: text_2,
            }))), (text_3 = "Noen kurs har oppgaver som må gjøres der og fungerer som en oppgave som kan gjøres på nivået. Oppgaver kan deltaker gjøre selv, med mindre oppgaven må godkjennes av en kursholder.", (el_12 = Caption1, createElement(el_12, {
                children: text_3,
            })))], ["children", reactApi_1.Children.toArray(Array.from(elems))])]))))], (elemsToUse = ((length(elems_1) <= 2) ? elems_1 : take(2, elems_1)), ["children", reactApi_1.Children.toArray(elemsToUse)])));
        })))))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => concat(mapIndexed((i, tl) => toArray(delay(() => {
            let el_36, elems_9, elems_8;
            const hasAllTasksForLevel = tl.RequiredTasks.every((reqTask) => contains(reqTask, completedTasks, {
                Equals: equals,
                GetHashCode: safeHash,
            }));
            return append(singleton((el_36 = Card, createElement(el_36, createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["borderWidth", 1]), delay(() => append(singleton(["width", 100 + "%"]), delay(() => append(singleton(["maxWidth", 500]), delay(() => append(singleton(["minHeight", 50]), delay(() => append(singleton(["maxHeight", 300]), delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["justifyContent", "center"]), delay(() => append(singleton(["flexDirection", "row"]), delay(() => (hasAllTasksForLevel ? singleton(["backgroundColor", tokens.colorPaletteGreenBackground2]) : empty()))))))))))))))))))))], (elems_9 = [createElement("div", createObj(ofArray([["style", {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: 100 + "%",
            }], (elems_8 = toList(delay(() => {
                let elems_4, el_18, elems_3;
                return append(singleton(createElement("div", createObj(ofArray([["style", {
                    width: 100 + "%",
                    display: "flex",
                    justifyContent: "space-between",
                }], (elems_4 = [createElement("div", {}), (el_18 = Subtitle2, createElement(el_18, {
                    children: tl.Name,
                })), createElement("div", createObj(singleton_1((elems_3 = toList(delay(() => {
                    let el_20, el_22;
                    return hasAllTasksForLevel ? singleton((el_20 = CheckmarkCircleRegular, createElement(el_20, {
                        fontSize: 16,
                        primaryFill: tokens.colorPaletteGreenForeground1,
                    }))) : singleton((el_22 = LockClosedRegular, createElement(el_22, {
                        fontSize: 16,
                    })));
                })), ["children", reactApi.Children.toArray(Array.from(elems_3))]))))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                    let el_24;
                    return append(singleton((el_24 = Caption1, createElement(el_24, {
                        style: {
                            color: tokens.colorNeutralForeground3,
                        },
                        children: tl.Description,
                        align: "center",
                    }))), delay(() => {
                        let elems_7, el_26, el_34, elems_6;
                        return (tl.RequiredTasks.length > 0) ? singleton(createElement("div", createObj(ofArray([["style", {
                            width: 100 + "%",
                            display: "flex",
                            flexDirection: "column",
                        }], (elems_7 = [(el_26 = Text$, createElement(el_26, {
                            children: "Betingelser",
                            style: {
                                display: "flex",
                                alignSelf: "start",
                                marginTop: 15,
                            },
                        })), (el_34 = List, createElement(el_34, createObj(singleton_1((elems_6 = toList(delay(() => map((require) => {
                            let elems_5, el_28, el_30;
                            const hasRequiredTask = contains(require, completedTasks, {
                                Equals: equals,
                                GetHashCode: safeHash,
                            });
                            const el_32 = ListItem;
                            return createElement(el_32, createObj(ofArray([["style", {
                                alignItems: "center",
                                display: "flex",
                                gap: 5 + "px ",
                            }], (elems_5 = [(el_28 = CheckmarkLockRegular, createElement(el_28, createObj(toList(delay(() => (hasRequiredTask ? singleton(["primaryFill", tokens.colorPaletteGreenForeground1]) : empty())))))), (el_30 = Caption2, createElement(el_30, {
                                children: require.Name,
                            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])])));
                        }, tl.RequiredTasks))), ["children", reactApi_1.Children.toArray(Array.from(elems_6))])))))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))) : empty();
                    }));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_9))])]))))), delay(() => {
                let el_38;
                return append((tl.TrackLevelCourses.length > 0) ? singleton((el_38 = Divider, createElement(el_38, {
                    vertical: true,
                    appearance: "strong",
                }))) : empty(), delay(() => append(map((tlc) => {
                    let elems_13;
                    const hasAllTasksForCourse = tlc.Course.Tasks.every((t) => contains(t, completedTasks, {
                        Equals: equals,
                        GetHashCode: safeHash,
                    }));
                    const el_52 = Card;
                    return createElement(el_52, createObj(ofArray([["appearance", "filled-alternative"], ["style", createObj(toList(delay(() => append(hasAllTasksForCourse ? singleton(["backgroundColor", tokens.colorPaletteGreenBackground2]) : empty(), delay(() => append(singleton(["width", 300]), delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexDirection", "row"]), delay(() => singleton(["justifyContent", "space-between"]))))))))))))], (elems_13 = toList(delay(() => {
                        let el_48, el_40, elems_12, el_42, elems_11, elems_10;
                        return append(singleton((el_48 = CardHeader, createElement(el_48, {
                            image: (el_40 = Image, createElement(el_40, {
                                style: {
                                    height: 48,
                                },
                                src: defaultArg(tlc.Course.ImageUrl, ""),
                            })),
                            header: tlc.Course.Name,
                            description: createElement("div", createObj(ofArray([["style", {
                                maxWidth: 200,
                            }], (elems_12 = [(el_42 = Caption1, createElement(el_42, {
                                style: {
                                    overflowWrap: "normal",
                                    display: "flex",
                                    flexGrow: 1,
                                    color: tokens.colorNeutralForeground3,
                                },
                                children: tlc.Course.Summary,
                            })), createElement("div", createObj(singleton_1((elems_11 = [createElement("div", createObj(ofArray([["style", {
                                display: "flex",
                                alignItems: "center",
                                gap: 5 + "px ",
                            }], (elems_10 = toList(delay(() => {
                                let el_44;
                                const completed = tlc.Course.Tasks.filter((t_1) => contains(t_1, completedTasks, {
                                    Equals: equals,
                                    GetHashCode: safeHash,
                                }));
                                return append(singleton((el_44 = CheckmarkLockRegular, createElement(el_44, createObj(toList(delay(() => ((completed.length === tlc.Course.Tasks.length) ? singleton(["primaryFill", tokens.colorPaletteGreenForeground1]) : empty()))))))), delay(() => {
                                    let el_46;
                                    return singleton((el_46 = Caption2, createElement(el_46, {
                                        children: `${completed.length}/${tlc.Course.Tasks.length}`,
                                    })));
                                }));
                            })), ["children", reactApi.Children.toArray(Array.from(elems_10))])])))], ["children", reactApi.Children.toArray(Array.from(elems_11))]))))], ["children", reactApi.Children.toArray(Array.from(elems_12))])]))),
                        }))), delay(() => {
                            let el_50;
                            return hasAllTasksForCourse ? singleton((el_50 = CheckmarkCircleRegular, createElement(el_50, {
                                fontSize: 16,
                                primaryFill: tokens.colorPaletteGreenForeground1,
                            }))) : empty();
                        }));
                    })), ["children", reactApi_1.Children.toArray(Array.from(elems_13))])])));
                }, sortBy((_arg_1) => _arg_1.Order, tl.TrackLevelCourses, {
                    Compare: comparePrimitives,
                })), delay(() => append(map((require_1) => {
                    let elems_14, el_58, el_54, el_56;
                    const userHasCompleted = completedTasks.some((completedTask) => (completedTask.Id === require_1.Id));
                    const el_60 = Card;
                    return createElement(el_60, createObj(ofArray([["style", createObj(toList(delay(() => append(userHasCompleted ? singleton(["backgroundColor", tokens.colorPaletteGreenBackground2]) : empty(), delay(() => append(singleton(["width", 100 + "%"]), delay(() => singleton(["maxWidth", 300]))))))))], ["size", "small"], ["appearance", "filled-alternative"], (elems_14 = [(el_58 = CardHeader, createElement(el_58, {
                        header: (el_54 = Caption2, createElement(el_54, {
                            children: require_1.Name,
                        })),
                        image: (el_56 = CheckmarkLockRegular, createElement(el_56, createObj(toList(delay(() => append(singleton(["fontSize", 20]), delay(() => (userHasCompleted ? singleton(["primaryFill", tokens.colorPaletteGreenForeground1]) : empty())))))))),
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_14))])])));
                }, tl.Tasks), delay(() => {
                    let el_62;
                    return (i < (track.TrackLevels.length - 1)) ? singleton((el_62 = Divider, createElement(el_62, {
                        vertical: true,
                        appearance: "strong",
                    }))) : empty();
                }))))));
            }));
        })), sortBy((_arg) => _arg.Order, track.TrackLevels, {
            Compare: comparePrimitives,
        })))));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_15))])])));
}

export function TrackView(trackViewInputProps) {
    let elems_1;
    const trackId = trackViewInputProps.trackId;
    const setCtx = useCtx()[1];
    const patternInput_1 = reactApi.useState(true);
    const patternInput_2 = reactApi.useState([]);
    const userCompletedTasks = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const setUserIsTakingTrack = patternInput_3[1];
    const patternInput_4 = reactApi.useState(undefined);
    const track = patternInput_4[0];
    useEffectOnce(() => {
        const pr = tap((res) => {
            if (res.tag === 0) {
                patternInput_2[1](res.fields[0]);
            }
            else {
                errorToast(setCtx, "getMyTasksError", "Noe gikk galt", "Kunne ikke hente mine gjennomførte oppgaver", undefined);
            }
        }, startAsPromise(Task.GetMy()));
        void (pr.catch((ex) => {
            toastServerError(setCtx, ex);
        }));
        const pr_1 = tap((res_1) => {
            if (res_1.tag === 1) {
                errorToast(setCtx, "getTracksError", "Kunne ikke hente kursløp", "Noe gikk galt", undefined);
            }
            else {
                patternInput_4[1](res_1.fields[0]);
            }
            patternInput_1[1](false);
        }, startAsPromise(Track.Get(trackId)));
        void (pr_1.catch((ex_1) => {
            toastServerError(setCtx, ex_1);
        }));
        const pr_2 = tap((res_2) => {
            if (res_2.tag === 1) {
            }
            else {
                setUserIsTakingTrack(res_2.fields[0].some((t_1) => (t_1.Id === trackId)));
            }
        }, startAsPromise(Track.GetMy()));
        void (pr_2.catch((ex_2) => {
            toastServerError(setCtx, ex_2);
        }));
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        width: 100 + "%",
        flexGrow: 1,
        gap: 25 + "px ",
    }], (elems_1 = toList(delay(() => {
        let el_4, elems, el, el_2;
        if (track != null) {
            const track$0027 = track;
            return append(singleton(createElement(HeaderCard, {
                track: track$0027,
                userIsTakingTrack: patternInput_3[0],
                setUserIsTakingTrack: setUserIsTakingTrack,
                userCompletedTasks: userCompletedTasks,
            })), delay(() => singleton(createElement(TrackOverview, {
                track: track$0027,
                completedTasks: userCompletedTasks,
            }))));
        }
        else {
            return patternInput_1[0] ? singleton((el_4 = Skeleton, createElement(el_4, createObj(ofArray([["style", {
                width: 100 + "%",
                display: "flex",
                flexDirection: "column",
                gap: 25 + "px ",
            }], (elems = [(el = SkeletonItem, createElement(el, {
                style: {
                    height: 35 + "vh",
                },
                animation: "wave",
                shape: "rectangle",
            })), (el_2 = SkeletonItem, createElement(el_2, {
                style: {
                    height: 55 + "vh",
                },
                animation: "wave",
                shape: "rectangle",
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems))])]))))) : singleton(dataFetchFailedView());
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

//# sourceMappingURL=TrackView.jsx.map
